import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from 'src/app/rest_services/msSurveyServices/survey.service';

@Component({
  selector: 'app-survey-detail',
  templateUrl: './survey-detail.component.html',
  styleUrls: ['./survey-detail.component.css']
})
export class SurveyDetailComponent implements OnInit {

  laoding: boolean= true;
  uuid:any;
  questions:any[]= [];


  constructor(
    private route : ActivatedRoute,
    private msSurvey : SurveyService
  ) { }

  ngOnInit(): void {
    this.uuid = this.route.snapshot.params['id']; 
    this.getSurvey();
  }


  getSurvey(){
    this.msSurvey.getSurveyQst(this.uuid);
    this.msSurvey.surveyQstSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          this.laoding= false;
          this.questions = data.survey.questions;
        }
      },
    )    
  }
}
